import React from 'react';
import {
  chakra,
  Box, HStack, VStack,
  OrderedList, ListItem, Heading,
  Text,
  Image,
  Button
} from '@chakra-ui/react';
import {CHART_COLORS} from '../theme';
import {IMAGE_PREFIX} from '../env';

const COMFORT_INPUTS_BG_HEIGHT = 78;
const COMFORT_INPUTS_BG_HEIGHT_SM = 40;

type Props = {
  estate: Estate,
  setComfort(index: number, comfort: Comfort): void
};

export default function ComfortInputs({
  estate, setComfort
}: Props) {
  return (
    <Box
      w={['91.30434782608695%', '91.30434782608695%', 'auto']}
      mt={['7.125rem', '7.125rem', "5.5rem"]}
      mx="auto"
      pt={[`${(COMFORT_INPUTS_BG_HEIGHT_SM + 15) / 16}rem`, `${(COMFORT_INPUTS_BG_HEIGHT + 20) / 16}rem`]}
      bgImage={`${IMAGE_PREFIX}img-graph-03.png`}
      bgSize={[`auto ${(COMFORT_INPUTS_BG_HEIGHT_SM + 15) / 16}rem`, `auto ${(COMFORT_INPUTS_BG_HEIGHT_SM + 15) / 16}rem`, `auto ${COMFORT_INPUTS_BG_HEIGHT / 16}rem`]}
      bgPosition="top center"
      bgRepeat="no-repeat"
    >
      <Heading as="h4" lineHeight="1.5625">
        書き出した分人それぞれに関する
        <chakra.br display={['none', 'none', 'inline']} />
        “心地よさ”を考えてみよう
      </Heading>
      <Text mt={[`${65 / 16}rem`, `${65 / 16}rem`, "9"]} fontSize={['15px', '15px', "lg"]} textAlign="center" color="gray.500">ハートをクリックして入力</Text>
      <OrderedList
        listStyleType="none"
        w={['full', 'full', `${64200 / 1024}%`]}
        mx="auto"
        p={['20px 32px 76px calc(22px - 2ch)', '20px 32px 76px calc(22px - 2ch)', "1.875rem 5.625rem 5rem calc(6.25rem - 1ch)"]}
        borderRadius="3xl"
        bgColor="gray.100"
      >
        {estate.dividuals.map((dividual, index) => (
          <ListItem key={dividual.id}>
            <ComfortInput index={index} dividual={dividual} setComfort={comfort => setComfort(index, comfort)} />
          </ListItem>
        ))}
      </OrderedList>
    </Box>
  );
}

type ComfortInputProps = {
  index: number;
  dividual: Dividual;
  setComfort(comfort: Comfort): void;
};

function ComfortInput({ index, dividual: { name, comfort }, setComfort }: ComfortInputProps) {
  const num = index < 9 ? `0${index + 1}` : `${index + 1}`;
  const imgOn = `${IMAGE_PREFIX}icon-heart-${num}_on.png`;
  const imgOff = `${IMAGE_PREFIX}icon-heart-${num}_off.png`;

  return (
    <VStack>
      <HStack w="full" justify="flex-start" spacing="6">
        <Box fontSize="2rem" w="2ch" whiteSpace="nowrap" color={CHART_COLORS[index].text} textAlign="end">{index + 1}</Box>
        <Box fontSize="2xl">{name}</Box>
      </HStack>
      <HStack w="full" justify="flex-end" spacing={['18.5px', '18.5px', "5"]}>
        {[...Array(comfort)].map((_, i) => <Button
          key={i}
          type="button"
          onClick={() => setComfort(i + 1 as Comfort)}
          p="0"
          display="block"
          w='auto'
          maxW='none'
          minW='0'
          h='auto'
          maxH='none'
          minH='0'
        ><Image src={imgOn} alt={`${i + 1}`} h={[`${27 / 16}rem`, `${27 / 16}rem`, `${30 / 16}rem`]} /></Button>)}
        {[...Array(5 - comfort)].map((_, i) => <Button
          key={comfort + i}
          type="button"
          onClick={() => setComfort(comfort + i + 1 as Comfort)}
          p="0"
          display="block"
          w='auto'
          maxW='none'
          minW='0'
          h='auto'
          maxH='none'
          minH='0'
        ><Image src={imgOff} alt={`${i + 1}`} h={[`${27 / 16}rem`, `${27 / 16}rem`, `${30 / 16}rem`]} /></Button>)}
      </HStack>
    </VStack>
  );
}
